import { Pipe, PipeTransform } from '@angular/core';
import { flatMap, sum, values } from 'lodash';

@Pipe({
    name: 'total',
    standalone: false
})
export class ReverseCalcTableRowTotalPipe implements PipeTransform {
  transform(valueChange: any, defaultValue: any): number {
    return sum(flatMap(valueChange || defaultValue, values));
  }
}
